/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */

import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import List from '../../components/List'
import Spinner from '../../components/Spinner'
import Button from '../../components/Button'
import { VISIT_URL } from '../../api/endpoints'
import { dispatch } from '../../root/store'
import {
  setActiveVisit,
  apiRequest,
  highlightNavbarSection,
  changeRoute
} from '../../root/actions'

import RightCarot from '../../assets/icons/carat_right.svg'
import style from './style'

export class Visit extends PureComponent {
  isVisitLoaded() {
    return (
      this.props.activeVisit !== null &&
      this.props.activeVisit.uuid === this.props.match.params.id
    )
  }

  isVisitCompleted() {
    return (
      this.props.activeVisit !== null && this.props.activeVisit.status.completed
    )
  }

  // Get requested visit and assessments if completed and is not the active visit.
  checkForRequestedVisit() {
    const uuid = this.props.match.params.id

    if (!this.isVisitLoaded()) {
      const request = {
        url: `${VISIT_URL}/${uuid}`,
        method: 'get'
      }

      const meta = {
        Component: 'Visit',
        assert: {
          item: uuid,
          test: 'isString'
        },
        onSuccess: result => {
          dispatch(
            setActiveVisit(result, {
              getActiveAssessments: true
            })
          )
          if (!this.isVisitCompleted()) {
            dispatch(changeRoute({ route: '/' }))
          }
        }
      }

      dispatch(apiRequest(request, meta))
    } else if (!this.isVisitCompleted()) {
      dispatch(changeRoute({ route: '/' }))
    }
  }

  componentDidMount() {
    this.checkForRequestedVisit()
    // Make sure navbar is highlighting the correct section.
    dispatch(highlightNavbarSection('history'))
  }

  render() {
    if (!this.isVisitLoaded() || !this.isVisitCompleted()) {
      return <Spinner />
    }

    const { classes, isMobile, activeVisit, currentVisit, user } = this.props
    const userName = user.full_name
    const headshotUrl = activeVisit.reportCard.demographics.headshot
    const headshotStyle = { backgroundImage: `url(${headshotUrl})` }
    const { route, reportPdf } = activeVisit
    const isCurrentVisit =
      currentVisit !== null && currentVisit.uuid === activeVisit.uuid

    const assessmentsBtn = {
      title: 'Pre-Visit Assessments',
      route: `${route}/assessments`,
      icon: { src: RightCarot }
    }

    const reportsBtn = {
      title: 'Health Reports',
      route: `${route}/reports`,
      icon: { src: RightCarot }
    }

    // Only show assessmentsBtn since Current Report already has reports for the Current Visit.
    const items = !isCurrentVisit
      ? [reportsBtn, assessmentsBtn]
      : [assessmentsBtn]

    const listProps = {
      items,
      action: this.props.changeRoute,
      className: 'mobile-padding',
      isNoTopBorder: true
    }

    const pageTitle = isCurrentVisit ? 'Current Visit' : 'Past Visit'

    return (
      <div className={`${classes.base}`}>
        <div className="date-container">
          <h2 className="mobile-padding ">{pageTitle}</h2>

          {isMobile && (
            <div className="mobile-padding">
              <div className="profileVisit">Visit on:</div>
              <div className="profileDate">{activeVisit.dayFormattedDate}</div>
            </div>
          )}
        </div>
        <div className="details-container">
          <div className="profileContainer">
            <div className="flex profileArea">
              <div className="profile-headshot">
                <div className="headshot-image" style={headshotStyle} />
              </div>
              <div className="flexCenter">
                <div>
                  <h1>{userName}</h1>
                  {!isMobile && (
                    <Fragment>
                      <div className="profileVisit">Visit on:</div>
                      <div className="profileDate">
                        {activeVisit.dayFormattedDate}
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            {!isMobile ? (
              <div className="flexCenter">
                <a href={reportPdf}>
                  <Button scheme="light">Download Health Report</Button>
                </a>
              </div>
            ) : null}
          </div>
          <br />
          {isMobile ? (
            <div className="mobile-padding">
              <a href={reportPdf}>
                <Button scheme="light" fullWidth>
                  Download Health Report
                </Button>
              </a>
            </div>
          ) : null}
          <br />
          <List {...listProps} />
          <br />
          <br />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeVisit: state.containers.app.get('activeVisit'),
    currentVisit: state.containers.app.get('currentVisit'),
    user: state.containers.app.get('user'),
    isMobile: state.containers.app.get('isMobile')
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ changeRoute }, dispatch)
}

Visit.propTypes = {
  activeVisit: PropTypes.object,
  currentVisit: PropTypes.object,
  user: PropTypes.object,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  changeRoute: PropTypes.func,
  classes: PropTypes.object
}

export default injectSheet(() => style)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Visit)
)
